var _rect, _path, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    viewBox: "0 0 200 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 50,
    rx: 10,
    fill: "#2E3A8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 15C17 10 10 10 5 13V37C10 34 17 34 25 37C33 34 40 34 45 37V13C40 10 33 10 25 15Z",
    fill: "#FDC830",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 35,
    fontFamily: "Arial",
    fontSize: 28,
    fill: "white",
    fontWeight: "bold"
  }, "Edu")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 35,
    fontFamily: "Arial",
    fontSize: 28,
    fill: "yellow",
    fontWeight: "bold"
  }, "Nexus")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.96d5447f50c2c52af89e099e3e847f92.svg";
export { ForwardRef as ReactComponent };